import TrackingEvent from "../TrackingEvent.interface";

export default abstract class BaseProvider {
  protected abstract isLoaded(): boolean

  protected abstract prepareEvent(event: TrackingEvent): object

  abstract sendProviderEvent(event: TrackingEvent): void
}
